import { Backdrop, CircularProgress, Stack, Typography } from "@mui/material";
import * as React from "react";

type BackdropLoadingProps = {
	isOpen: boolean;
	/** Texto abaixo do indicador (plano 22/10/2026, Frente 2): diz ao usuário o que está em andamento. */
	mensagem?: string;
	/**
	 * Por cima dos diálogos (zIndex do modal + 1). Sem isto o indicador fica na camada do drawer
	 * (1202), ATRÁS de qualquer Dialog aberto (1300) — o usuário não vê nada e acha que travou.
	 */
	acimaDosDialogos?: boolean;
};

const BackdropLoading: React.FC<BackdropLoadingProps> = ({ isOpen, mensagem, acimaDosDialogos = false }) => {
	return (
		<Backdrop
			sx={{ zIndex: (theme) => (acimaDosDialogos ? theme.zIndex.modal + 1 : theme.zIndex.drawer + 2) }}
			open={isOpen}
		>
			<Stack alignItems="center" spacing={2}>
				<CircularProgress sx={{ color: "common.white" }} />
				{mensagem && (
					<Typography sx={{ color: "common.white", fontWeight: 500, textAlign: "center", px: 2 }}>
						{mensagem}
					</Typography>
				)}
			</Stack>
		</Backdrop>
	);
};

export default BackdropLoading;
